import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, inject } from '@angular/core';
import { RemoteCancelService } from '../_services/remote-cancel.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BusinessService } from '../business.service';
import { Store } from '../_models/store';
import { StoreService } from '../_services/store.service';
import { AuthenticationService } from '../_services/authentication.service';
import { Router } from '@angular/router';
import { UnreadService } from '../_services/unread-message.service';
import { debounceTime, filter as rxFilter, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { PermissionService } from '../_services/permission.service';
import { DOCUMENT } from '@angular/common';
import { TerminalStatusService } from '../_services/terminal-status.service';
import { RefreshService } from '../_services/refresh.service';
import { Modules } from '../constants';
import { Subject, Subscription } from 'rxjs';
import { OrderWebsocketService } from '../_services/websocket.service';
import { IMqttMessage, IPublishOptions, MqttService } from 'ngx-mqtt';
import { IClientSubscribeOptions } from 'mqtt/types/lib/client-options';
import { DigitalDisplayService } from '../_services/digital-display.service';
import { FrontFacingMqttService } from '../_services/front-facing-mqtt.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { POSService } from '../_services/pos-service';
import { CallerIdService, CallerIdNotification } from '../_services/caller-id.service';
import { MenuServiceV2 } from '../_services/menu-v2.service';
import { SyncQueueService } from '../_services/sync-queue.service';
import { LocalOrderStateService } from '../_services/local-order-state.service';
import { posSyncDb } from '../_services/pos-sync-db';
import { markNavLanding } from '../_models/ui-order';

@Component({
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.scss']
})
export class HomeLayoutComponent implements OnInit, OnDestroy {
  opened: boolean = true;
  stores;
  selectedStoreName
  store;
  toolbarForm;

  filteredStores;
  filter = new UntypedFormControl();
  contentMargin = 257;
  errorMsg;
  isLoading;
  elem;
  isFullScreen = false;
  private cssOnlyFullscreen = false; // true when Fullscreen API was rejected and CSS fallback is active

  statusSocket;
  terminalId;
  isOnline;
  isPing = false;

  statusSubs;
  statusSocketSubject;
  soundOpenCLose = false;
  isOrdersView: boolean;

  /**
   * ENG-5242: mutes the looping new-order alert without changing the order flow.
   *
   * `isOrdersView` means "an online order is sitting unaccepted" -- it drives both the
   * looping <audio> and the blinking Orders tab, because both keyed off the single
   * `view_notified` boolean. A store on manual accept (auto_accept_orders = false) had no
   * way to keep the VIEW step but drop the noise. This flag splits them: the template
   * gates only the <audio> on it, so the blink survives and staff still get a cue.
   *
   * Read through getFeatureFlag() so a store with no row for the flag -- the common case,
   * since it is not seeded -- returns false and keeps the sound on. Defaulting to "muted"
   * on a missing key would silence every store at once.
   */
  get isNewOrderSoundDisabled(): boolean {
    return !!this.store?.getFeatureFlag?.('disable_new_order_sound');
  }
  idStore: any;
  lost: boolean;
  isSocketActive = false;
  isDeviceActive = false;
  onMob: Subscription;

  retryInterval;
  retrying = false;
  private orderAccept: Subscription;
  private subscription: Subscription;
  private destroySubject: Subject<void> = new Subject<void>();
  private sideNav: Subscription;
  pingIntervalId;
  mqtSub;
  // ENG-4418: Separate subscription variable for the caller-ID MQTT topic so that
  // the order-status subscription is not overwritten and leaked.
  mqtCallerIdSub;
  mqtFutureOrderSub;
  mqtMenuUpdateSub;
  menuVersionCheckInterval;
  alertSound;
  fullScreenUpdateSub: Subscription;
  onscrollTop: Subscription;
  callQueueArray: any[] = [];
  @HostListener("window:beforeunload")
  canDeactivate() {
    this.closeFullscreen();
  }
  isTrainingMode: boolean = false;
  private remoteCancel = inject(RemoteCancelService);
  trainModSub: Subscription;

  constructor(
    private businessService: BusinessService,
    private storeService: StoreService,
    private unreadService: UnreadService,
    private authService: AuthenticationService,
    private router: Router,
    private permissionService: PermissionService,
    private terminalStatusService: TerminalStatusService,
    private refreshService: RefreshService,
    @Inject(DOCUMENT) private document: any,
    private _snackBar: MatSnackBar,
    private orderWebsocketService: OrderWebsocketService,
    private mqttService: MqttService,
    private DigitalDisplay: DigitalDisplayService,
    private mq: FrontFacingMqttService,
    private posService: POSService,
    private callerIdService: CallerIdService,
    private menuService: MenuServiceV2,
    private syncQueue: SyncQueueService,
    private localOrderState: LocalOrderStateService,
  ) {
    this.orderAccept = this.storeService.isOrderView.pipe(takeUntil(this.destroySubject)).subscribe(value => {
      this.isOrdersView = value;
    });

    // `value` is the state the POS wants, applied as-is. Previously this assigned
    // `opened = value` and then called toggleSideNav(1), which inverted it right
    // back — so Show/Hide flipped state instead of setting it.
    this.sideNav = this.storeService.sideNavOpenClose.pipe(takeUntil(this.destroySubject)).subscribe(value => {
      this.setSideNav(value, !value);
    });

    this.fullScreenUpdateSub = this.storeService.fillScreenUpdateFromPOS.pipe(takeUntil(this.destroySubject)).subscribe(value => {
      this.isFullScreen = value;
      this.setSideNav(true);

    });
    if (window.innerWidth <= 459) {
      this.onMob = this.posService.posMenuHeight.pipe(takeUntil(this.destroySubject)).subscribe(data => {
        if (data == 'full-screen') {
          const sidenavContent = document.querySelector('.mat-sidenav-container') as HTMLElement;
          if (sidenavContent) {
            sidenavContent.style.paddingTop = `0px`;
          }
        } else if (data == 'close-screen') {
          const sidenavContent = document.querySelector('.mat-sidenav-container') as HTMLElement;
          if (sidenavContent) {
            sidenavContent.style.paddingTop = `60px`;
          }
          const topHeader = document.querySelector('.mat-toolbar') as HTMLElement;
          if (topHeader) {
            topHeader.style.visibility = 'visible';
          }
        }
      });
    }

    this.onscrollTop = this.posService.scrolltoTop.pipe(takeUntil(this.destroySubject)).subscribe(data => {
      if (data) {
        this.scrollToTop();
      }
    });

    this.trainModSub = this.storeService.trainingModUpdate.pipe(takeUntil(this.destroySubject)).subscribe(data => {
      this.isTrainingMode = data;
    })

  }

  scrollToTop(): void {
    const drawerContents = document.querySelectorAll('.mat-drawer-content') as NodeListOf<HTMLElement>;
    drawerContents.forEach(container => {
      container.scrollTop = 0;
    });
  }

  ngOnDestroy(): void {
    if (this.statusSubs) {
      this.statusSubs.unsubscribe();
    }

    if (this.statusSocketSubject) {
      this.statusSocketSubject.unsubscribe();
    }

    if (this.orderAccept) {
      this.orderAccept.unsubscribe();
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.sideNav) {
      this.sideNav.unsubscribe();
    }
    if (this.mqtFutureOrderSub) {
      this.mqtFutureOrderSub.unsubscribe();
    }
    if (this.mqtMenuUpdateSub) {
      this.mqtMenuUpdateSub.unsubscribe();
    }
    if (this.menuVersionCheckInterval) {
      clearInterval(this.menuVersionCheckInterval);
    }
    this.destroySubject.next();
    if (this.onMob) {
      this.onMob.unsubscribe();
    }

    if (this.onscrollTop) {
      this.onscrollTop.unsubscribe();
    }
  }

  ngOnInit() {
    this.elem = document.documentElement;
    this.opened = (window.innerWidth <= 1024) ? false : true;
    if (!this.opened && window.innerWidth > 768) {
      this.contentMargin = 65;
    }
    this.toolbarForm = new UntypedFormGroup({
      store: new UntypedFormControl()
    });

    this.mqttService.onConnect.pipe(takeUntil(this.destroySubject)).subscribe(x => {
      this.isSocketActive = true;
      console.log(`[MENU_MQTT_DEBUG] MQTT CONNECTED`);

      // G-3: Catch-up on reconnect — check if we missed MQTT events while disconnected.
      // Applies to local-first POS and new POS cat/item view stores that use the menu cache.
      if (this.store?.feature_flag?.['local_first_pos'] || this.store?.feature_flag?.['new_pos_cat_item_view']) {
        const currentStoreId = localStorage.getItem("currentStore");
        if (currentStoreId) {
          const localVersion = this.menuService.getMenuVersion(currentStoreId);
          if (localVersion > 0) {
            this.menuService.checkMenuVersion(currentStoreId).subscribe(resp => {
              const freshLocal = this.menuService.getMenuVersion(currentStoreId);
              if (resp.version > freshLocal) {
                // Don't call clearMenuCache — keep L1 populated while HTTP fetches.
                this.menuService.setMenuVersion(currentStoreId, resp.version);
                this.menuService.syncFullMenu(String(currentStoreId)).then(() => {
                  this.storeService.menuRefreshTrigger.next();
                });
              }
            });
          }
        }
      }
    });

    this.mqttService.onReconnect.pipe(takeUntil(this.destroySubject)).subscribe(x => {
      console.log(`[MENU_MQTT_DEBUG] MQTT RECONNECTING`);
    });

    this.mqttService.onClose.pipe(takeUntil(this.destroySubject)).subscribe(x => {
      this.isSocketActive = false;
      console.log(`[MENU_MQTT_DEBUG] MQTT CLOSED`);
    });

    this.mqttService.onMessage.pipe(takeUntil(this.destroySubject)).subscribe(x => {
    });

    // The search pipeline must only run for TYPED text. mat-autocomplete writes the
    // selected store OBJECT into this same control on selection, which used to
    // re-enter the pipeline, blank `stores`, and refetch with the object as the
    // query param -- racing the store switch and letting a stale/filtered list
    // overwrite the selection. Ignore anything that isn't a search string.
    //
    // Superseded (kept per convention):
    // this.filter.valueChanges
    //   .pipe(
    //     debounceTime(500),
    //     tap(() => {
    //       this.errorMsg = "";
    //       this.stores = [];
    //       this.isLoading = true;
    //     }),
    //     switchMap(value => this.businessService.getStores(value))
    //   ).pipe(takeUntil(this.destroySubject))
    //   .subscribe(data => {
    //     this.stores = data.map(store => Object.assign(new Store(), store));
    //   });
    this.filter.valueChanges
      .pipe(
        rxFilter(value => typeof value === 'string'),
        debounceTime(500),
        tap(() => {
          this.errorMsg = "";
          this.stores = [];
          this.isLoading = true;
        }),
        // master guarded here against the control holding a store OBJECT after a
        // selection; the rxFilter above now drops non-strings before this point, so
        // the unwrap is unreachable. Kept as the single string path.
        //
        // Superseded (kept per convention):
        // switchMap(value => this.businessService.getStores(
        //   value && typeof value === 'object' ? value.store_name : value))
        switchMap(value => this.businessService.getStores(value))
      ).pipe(takeUntil(this.destroySubject))
      .subscribe(data => {
        this.stores = data.map(store => Object.assign(new Store(), store));
        this.isLoading = false;
      });

    // ENG-4644: Pre-load store config from Dexie so it's available instantly
    // while getStores() HTTP is in-flight. The HTTP response overwrites below.
    const cachedStoreId = localStorage.getItem("currentStore");
    if (cachedStoreId && !this.store) {
      this.storeService.loadStoreFromCache(cachedStoreId).then(cached => {
        if (cached && !this.store) {
          this.store = cached;
          this.setStoreFilterDisplay(this.store);
          this.storeService.changeStore(this.store);
        }
      });
    }

    this.businessService.getStores().pipe(takeUntil(this.destroySubject))
      .subscribe(data => {
        this.stores = data.map(store => Object.assign(new Store(), store));
        if (!localStorage.getItem("currentStore")) {

          this.store = this.stores[0];
          localStorage.setItem("currentStore", this.store.id);
          localStorage.setItem("storeTimezone", this.store.time_zone);
        } else {
          let currentStoreId = localStorage.getItem("currentStore")
          let store = this.stores.filter(store => store.id === +currentStoreId);

          // `.filter()` returns [] when there is no match, and [] is TRUTHY -- so the
          // else branch never ran and `this.store` was silently set to undefined,
          // leaving the sidenav with no store name. Test for an actual match.
          //
          // Superseded (kept per convention):
          // if (store) {
          //   this.store = store[0];
          // } else {
          //   this.store = this.stores[0];
          // }
          if (store.length) {
            this.store = store[0];
          } else if (this.store && String(this.store.id) === String(currentStoreId)) {
            // A store is already selected in this component and it matches the saved
            // id -- the list response simply does not carry it (partial/filtered
            // payload). Falling through to stores[0] here is what silently reverted
            // a fresh selection, so keep what we have.
          } else {
            this.store = this.stores[0];
            // Saved store is gone/not permitted -- repoint localStorage at the
            // fallback so the rest of the app doesn't keep using the stale id.
            if (this.store) {
              localStorage.setItem("currentStore", this.store.id);
              localStorage.setItem("storeTimezone", this.store.time_zone);
            }
          }
        }
        if (this.store) {
          this.setStoreFilterDisplay(this.store);

          // ENG-4644: Immediately push the list-endpoint store data through the
          // BehaviorSubject so all components (orders, pos-menu) receive fresh
          // feature_flag values right away — don't wait for syncStoreData HTTP.
          this.storeService.changeStore(this.store);

          // Start all operations immediately — no waiting for store detail
          this.unreadService.unreadMessages(this.store.id);
          this.permissionService.getUserPermission(this.store.id);
          this.idStore = this.store.id;
          this.initMqtt();

          // Menu sync — start immediately using list-endpoint feature flags.
          // The list endpoint already includes feature_flag, so local_first_pos
          // is available without waiting for the v2 detail call.
          // Also sync for new_pos_cat_item_view stores: _enrichItemsWithPortionNames
          // and _checkModifiersForSimpleItems rely on L1 cache being pre-populated;
          // without syncFullMenu they fall through to per-item HTTP calls every load.
          if (this.store?.feature_flag?.['local_first_pos'] || this.store?.feature_flag?.['new_pos_cat_item_view']) {
            this.menuService.syncFullMenu(String(this.store.id));
          }

          // Collapse sidebar for new POS layout
          if (this.store.getFeatureFlag && this.store.getFeatureFlag('new_pos_cat_item_view') && this.opened) {
            this.opened = false;
            this.contentMargin = window.innerWidth > 768 ? 65 : 0;
            localStorage.setItem('side-nav', 'false');
            const sidenavContent = document.querySelector('.mat-drawer-content') as HTMLElement;
            if (sidenavContent) {
              sidenavContent.style.marginLeft = `${this.contentMargin}px`;
            }
          }

          if (this.store.feature_flag?.auto_full_screen_mode) {
            if (window.innerWidth > 768) {
              this.openFullscreen();
            }
          } else {
            if (this.isFullScreen) {
              this.closeFullscreen();
            }
          }

          // ENG-4644: Sync fresh store data in background — updates all cache
          // layers so subsequent reads (store switch, MQTT refresh, etc.) have
          // the latest settings. Does NOT block menu loading or POS login.
          this.storeService.syncStoreData(this.store.id).then((freshStore) => {
            this.store = freshStore;
            this.setStoreFilterDisplay(freshStore);
          }).catch(() => {
            this.storeService.changeStore(this.store);
          });
        }

        if (this.store) {
          this.storeService.syncTrainingFromStore(this.store?.store_data?.enable_training_mode);
        }

        if (!localStorage.getItem("store_type")) {
          this.store = this.stores[0];
          localStorage.setItem("store_type", this.store.store_type);
        }
      });

    document.addEventListener("fullscreenchange", this.handleFullscreenChange.bind(this));
  }

  handleFullscreenChange() {
    if (!document.fullscreenElement && !this.cssOnlyFullscreen) {
      this.isFullScreen = false;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!document.fullscreenElement && !this.cssOnlyFullscreen) {
        this.isFullScreen = false;
      }
    }, 3000);
  }

  storeSelected(store: Store) {
    setTimeout(() => {
      localStorage.removeItem("order_hash");
      localStorage.removeItem("currentPIN");
      let currentStoreId = localStorage.getItem("currentStore");
      // ENG-4644: Clear old store's menu + store config caches on store switch
      if (currentStoreId) {
        this.menuService.clearMenuCache(currentStoreId);
        posSyncDb.store_config.delete(currentStoreId).catch(() => {});
      }
      // ENG-4644: Clear sync queue + order snapshots on store switch
      // Prevents old store's mutations and stale order data from leaking
      this.syncQueue.clearAll();
      this.localOrderState.resetForStoreSwitch();
      this.store = store
      // ENG-4644: Trigger syncFullMenu for the newly selected store, explicitly by
      // id, after the old store's cache is cleared. (Historically this had to be
      // done here because the ngOnInit() re-run at the end of this method synced
      // off the stale localStorage id; that re-run is gone, but syncing the new
      // store explicitly is still the correct thing to do on a switch.)
      if (store?.feature_flag?.['local_first_pos'] || store?.feature_flag?.['new_pos_cat_item_view']) {
        this.menuService.syncFullMenu(String(store.id));
      }
      this.setStoreFilterDisplay(store)
      if (store.id != currentStoreId) {
        // ENG-5687: through the landing stop, so the new store's own side-nav order decides.
        // The permission object held right now belongs to the OLD store; the landing waits
        // for the one requested below.
        let current = null;
        this.permissionService.current.pipe(take(1)).subscribe(p => current = p);
        markNavLanding(current);
        this.router.navigate(['home'])
      }
      this.storeService.changeStore(store)
      setTimeout(() => {
        const stre = {
          store_data: store,
          number: 1
        }
        this.storeService.isStoreChange.next(stre);
      }, 1000);
      this.unreadService.unreadMessages(store.id)
      setTimeout(() => {

        this.initMqtt();
      }, 2000)
      if (this.store.feature_flag.auto_full_screen_mode) {
        if (window.innerWidth > 768) {
          this.openFullscreen();
        }
      } else {
        if (this.isFullScreen) {
          this.closeFullscreen();
        }
      }
      if (this.store) {
        this.storeService.syncTrainingFromStore(this.store?.store_data?.enable_training_mode);
      }
      this.DigitalDisplay.unreadMessages(store.id);

      // Re-running ngOnInit() here was what reverted the store in the sidenav. It
      // re-issued getStores() with NO search term and then re-derived `this.store`
      // from localStorage against that list -- and when the list came back without
      // the freshly-picked store (or later than the in-flight search response), the
      // `this.store = this.stores[0]` fallback overwrote both `this.store` AND
      // localStorage.currentStore, undoing the switch. It also stacked a duplicate
      // set of valueChanges / getStores / MQTT subscriptions on every switch, so
      // each further switch added one more racer writing `this.store`.
      //
      // Superseded (kept per convention):
      // this.ngOnInit();
      //
      // Instead do the narrow work the re-init was actually wanted for: refresh the
      // permissions for the new store and pull its full detail record. The selected
      // store is passed explicitly, so nothing reads the old id back out of storage.
      this.permissionService.getUserPermission(store.id);
      this.idStore = store.id;
      this.storeService.syncStoreData(store.id).then((freshStore) => {
        // Guard against a slow response for a store the user has since switched
        // away from -- only apply it if this is still the selected store.
        if (String(freshStore?.id) !== String(this.store?.id)) return;
        this.store = freshStore;
        this.setStoreFilterDisplay(freshStore);
      }).catch(() => {
        this.storeService.changeStore(store);
      });
    }, 500);
  }

  /**
   * The store input is a [formControl]="filter" + [matAutocomplete]. Angular's form
   * control owns the rendered value, so the [value]="selectedStoreName" binding that
   * used to sit on the same input was ignored and the field looked empty even when a
   * store WAS selected. Seed the control itself (emitEvent:false so this does not
   * trigger the search valueChanges and refetch the list). displayWith=storeName
   * expects a store object, so set the object -- not the name.
   */
  private setStoreFilterDisplay(store) {
    if (!store) return;
    this.selectedStoreName = store.store_name;
    this.filter.setValue(store, { emitEvent: false });
  }

  storeName(store) {
    if (store) {
      return store.store_name;
    } else {
      return '';
    }
  }

  async logout() {
    this.closeFullscreen();
    await this.authService.logout();
    this.storeService.clearTrainingMode();
    this.router.navigate(['/login']);
  }

  isSmallScreen() {
    return window.innerWidth < 769 ? true : false;
  }

  toggleSideNav(e) {
    // Flip, then apply. The hamburger (e == 0) is a true toggle; stream-driven
    // callers use setSideNav() so the requested state is applied verbatim
    // instead of being inverted out from under them.
    this.applySideNav(!this.opened, e);
  }

  /**
   * Set the left nav to an explicit state.
   *
   * `toggleSideNav` blind-flips `opened`, which desynced the POS Show/Hide button
   * from reality: the sideNavOpenClose subscription assigned `opened = value` and
   * then immediately inverted it. Callers that know the state they want (the POS
   * Show/Hide button, fullscreen exit restore) go through here.
   *
   * `hideCompletely` collapses the rail to 0px (`snav-full-closed`) rather than the
   * 65px icon rail — that is what the POS "Hide" button asks for.
   */
  setSideNav(open: boolean, hideCompletely: boolean = false) {
    this.applySideNav(open, hideCompletely ? 1 : 0);
  }

  /**
   * Single place that writes the left nav's state to the DOM.
   * `e == 1` means "hide completely" (0px), `e == 2` forces open, anything else is
   * the normal 257px / 65px open-closed pair.
   */
  private applySideNav(open: boolean, e) {
    this.opened = open;
    localStorage.setItem('side-nav', `${this.opened}`);
    this.contentMargin = this.isSmallScreen() ? 0 : (this.opened ? 257 : 65);

    const sidenav = document.querySelector('.mat-sidenav') as HTMLElement;
    if (sidenav) {
      sidenav.classList.remove('fullscreen-mode');
      if (!this.opened && e == 1) {
        sidenav.classList.add('snav-full-closed');
        this.contentMargin = 0;
      } else {
        if (sidenav.classList.contains('snav-full-closed')) {
          sidenav.classList.remove('snav-full-closed');
        }
      }
      if (e == 2) {
        this.opened = true
      }
    }
    const sidenavContent = document.querySelector('.mat-drawer-content') as HTMLElement;
    if (sidenavContent) {
      sidenavContent.classList.remove('fullscreen-mode');
      sidenavContent.style.marginLeft = `${this.contentMargin}px`;
    }
  }

  dummy() { }

  openFullscreen() {
    const applyFullscreenStyles = () => {
      const topHeader = document.querySelector('.mat-toolbar') as HTMLElement;
      if (topHeader) {
        topHeader.style.visibility = 'hidden';
      }
      const appContainer = document.querySelector('.app-container') as HTMLElement;
      if (appContainer) {
        appContainer.style.top = '0px';
      }
      this.isFullScreen = true;
      this.storeService.fullScreenUpdate.next(true);
      this.posService.posMenuHeight.next('full-screen');
    };

    try {
      let fullscreenPromise: Promise<void> | undefined;

      if (this.elem.requestFullscreen) {
        fullscreenPromise = this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        fullscreenPromise = this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        fullscreenPromise = this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        fullscreenPromise = this.elem.msRequestFullscreen();
      }

      if (fullscreenPromise) {
        fullscreenPromise
          .then(() => {
            this.cssOnlyFullscreen = false;
            applyFullscreenStyles();
          })
          .catch(() => {
            // Native Fullscreen API rejected (e.g. Android requires user gesture).
            // Apply CSS-only fullscreen as fallback — hides toolbar, expands layout.
            this.cssOnlyFullscreen = true;
            applyFullscreenStyles();
          });
      } else {
        // No Fullscreen API available at all — apply CSS-only fullscreen
        this.cssOnlyFullscreen = true;
        applyFullscreenStyles();
      }
    } catch (err) {
      // Fullscreen API threw — apply CSS-only fallback
      this.cssOnlyFullscreen = true;
      applyFullscreenStyles();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    try {
      let exitPromise: Promise<void> | undefined;

      if (this.document.exitFullscreen) {
        exitPromise = this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        exitPromise = this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        exitPromise = this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        exitPromise = this.document.msExitFullscreen();
      }

      if (exitPromise) {
        exitPromise.catch(() => {});
      }
    } catch (err) {}

    document.body.removeEventListener('click', this.closeFullscreen);
    const topHeader = document.querySelector('.mat-toolbar') as HTMLElement;
    if (topHeader) {
      topHeader.style.visibility = 'visible';
    }
    this.isFullScreen = false;
    this.cssOnlyFullscreen = false;
    this.storeService.fullScreenUpdate.next(false);
    this.posService.posMenuHeight.next('close-screen');
  }

  check() {
  }

  publish(payload: string) {
    const qos = 2;
    const terminalId = localStorage.getItem('selectedTerminal');
    this.mqttService.unsafePublish(`/link/${terminalId}/sub`, payload, { qos } as IPublishOptions);
  }

  reconnectMqttServer() {
    this.mqttService.connect();
    const payload = {
      command: 'RECONNECT'
    };
    this.publish(JSON.stringify(payload));
  }

  // BotOrder.order_counter already carries its own '#', so prefixing another one
  // rendered the toast as "Future order ##2610-0616".
  formatOrderCounter(orderCounter: string): string {
    const counter = (orderCounter ?? '').toString().trim();
    if (!counter) {
      return '';
    }
    return counter.startsWith('#') ? counter : `#${counter}`;
  }

  initMqtt() {
    // ENG-4418: Unsubscribe any existing MQTT topic subscriptions before re-subscribing.
    // initMqtt() can be called more than once (e.g. on store change), previously causing
    // duplicate message handlers that invoked each callback multiple times.
    if (this.mqtSub) {
      this.mqtSub.unsubscribe();
      this.mqtSub = null;
    }
    if (this.mqtCallerIdSub) {
      this.mqtCallerIdSub.unsubscribe();
      this.mqtCallerIdSub = null;
    }
    if (this.mqtFutureOrderSub) {
      this.mqtFutureOrderSub.unsubscribe();
      this.mqtFutureOrderSub = null;
    }
    if (this.mqtMenuUpdateSub) {
      this.mqtMenuUpdateSub.unsubscribe();
      this.mqtMenuUpdateSub = null;
    }
    if (this.menuVersionCheckInterval) {
      clearInterval(this.menuVersionCheckInterval);
      this.menuVersionCheckInterval = null;
    }

    let currentStoreId = localStorage.getItem("currentStore");
    this.mqtSub = this.mqttService.observe(`/order/${currentStoreId}/sub`,
      { qos: 1 } as IClientSubscribeOptions).pipe(takeUntil(this.destroySubject)).subscribe((message: IMqttMessage) => {
        const orderResponse = JSON.parse(message.payload.toString());
        const aa = orderResponse.bot_order;
        // ENG-5867: the ticket on screen was cancelled elsewhere — tell the cashier now, not at payment.
        this.remoteCancel.onOrderUpdate(aa);
        if (aa.view_notified == false && aa.is_pos == false) {
          this.storeService.isOrderView.next(true);
          this.businessService.orderSet.next(orderResponse);
        } else {
          this.businessService.orderSet.next(orderResponse);
          this.storeService.isOrderView.next(false);
        }

        if (aa.is_tab_open == true) {
          this.refreshService.refreshModule(Modules.OPEN_TAB);
        } else {
          this.refreshService.refreshModule(Modules.CLOSED_TAB);
        }
      });

    // ENG-4418: Use separate mqtCallerIdSub variable; previously this reassigned mqtSub
    // immediately, leaking the order-status subscription on every initMqtt() call.
    this.mqtCallerIdSub = this.mqttService.observe(`/caller_id_notification/${currentStoreId}/sub`,
      { qos: 1 } as IClientSubscribeOptions).pipe(takeUntil(this.destroySubject)).subscribe((message: IMqttMessage) => {
        const store_id = localStorage.getItem("currentStore");
        const callNotification = JSON.parse(message.payload.toString());
        if (Number(store_id) === callNotification.store_id) {
          this.callerIdService.callSet.next(callNotification as CallerIdNotification);
        } else {
        }
      });

    this.mqtFutureOrderSub = this.mqttService.observe(`/future_order/${currentStoreId}/sub`,
      { qos: 1 } as IClientSubscribeOptions).pipe(takeUntil(this.destroySubject)).subscribe((message: IMqttMessage) => {
        const payload = JSON.parse(message.payload.toString());

        if (payload.type === 'future_order_due_soon') {
          const count = payload.count || 0;
          const firstOrder = payload.orders?.[0];
          const name = firstOrder?.customer_name || 'Customer';
          const msg = count === 1
            ? `Future order from ${name} is due soon`
            : `${count} future orders are due soon`;
          this._snackBar.open(msg, 'VIEW', { duration: 10000 });
        } else if (payload.type === 'future_order_printed') {
          this._snackBar.open(`Future order ${this.formatOrderCounter(payload.order_counter)} sent to kitchen`, 'OK', { duration: 5000 });
        } else if (payload.type === 'future_order_print_failed') {
          this._snackBar.open(`Future order ${this.formatOrderCounter(payload.order_counter)} failed to print`, 'OK', { duration: 10000 });
        }

        this.refreshService.refreshModule(Modules.FUTURE_TAB);
      });

    // ENG-4644: Subscribe to menu update MQTT topic for real-time menu updates.
    // G-1/G-2: Handles granular availability deltas, item/modifier edits, and
    // full-refresh with version tracking. Applies to ALL stores so admin edits
    // and stock changes reflect on POS in real-time.
    console.log(`[MENU_MQTT_DEBUG] Subscribing to /menu_update/${currentStoreId}/sub`);
    this.mqtMenuUpdateSub = this.mqttService.observe(`/menu_update/${currentStoreId}/sub`,
      { qos: 1 } as IClientSubscribeOptions).pipe(takeUntil(this.destroySubject)).subscribe((message: IMqttMessage) => {
        try {
          const payload = JSON.parse(message.payload.toString());
          console.log(`[MENU_MQTT_DEBUG] RECEIVED store=${currentStoreId} type=${payload.type} version=${payload.version}`, payload);

          // G-2: Track menu version
          const prevVersion = this.menuService.getMenuVersion(currentStoreId);
          if (payload.version) {
            this.menuService.setMenuVersion(currentStoreId, payload.version);
          }

          if (payload.type === 'availability' && payload.items?.length) {
            console.log(`[MENU_MQTT_DEBUG] Handling AVAILABILITY update, items=${payload.items.length}`);
            // G-1: Granular availability update — patch only the changed items
            const statusChanged = this.menuService.updateItemsAvailability(currentStoreId, payload.items);
            if (payload.version) this.menuService.setMenuVersion(currentStoreId, payload.version);
            if (statusChanged) {
              this.storeService.menuRefreshTrigger.next();
            }
          } else if (payload.type === 'menu_item_edit' && payload.item_id) {
            console.log(`[MENU_MQTT_DEBUG] Handling MENU_ITEM_EDIT, item_id=${payload.item_id} action=${payload.action}`);
            // G-1 ext: Single menu item edit — patch or remove only that item
            this.menuService.applyMenuItemDelta(currentStoreId, payload.item_id, payload.changes || {}, payload.action);
            if (payload.version) this.menuService.setMenuVersion(currentStoreId, payload.version);
            this.storeService.menuRefreshTrigger.next();
          } else if (payload.type === 'modifier_edit' && payload.modifier_id) {
            console.log(`[MENU_MQTT_DEBUG] Handling MODIFIER_EDIT, modifier_id=${payload.modifier_id} action=${payload.action}`);
            // G-1 ext: Single modifier edit — patch or remove only that modifier
            this.menuService.applyModifierDelta(currentStoreId, payload.modifier_id, payload.changes || {}, payload.action);
            if (payload.version) this.menuService.setMenuVersion(currentStoreId, payload.version);
            this.storeService.menuRefreshTrigger.next();
          } else if (payload.type === 'menu_items_batch' && payload.items?.length) {
            console.log(`[MENU_MQTT_DEBUG] Handling MENU_ITEMS_BATCH, items=${payload.items.length} action=${payload.action}`);
            // ENG-4644: Batch menu item updates (e.g. from update_menu_item_group)
            const needsFullSync = this.menuService.applyMenuItemsBatch(currentStoreId, payload.items, payload.action || 'updated', payload.menu_item_group);
            if (payload.version) this.menuService.setMenuVersion(currentStoreId, payload.version);
            if (needsFullSync) {
              console.log(`[MENU_MQTT_DEBUG] MENU_ITEMS_BATCH needs full sync — items missing from cache`);
              // Items missing from cache (e.g. previously removed) — full sync
              this.menuService.clearMenuCache(String(currentStoreId));
              this.menuService.syncFullMenu(String(currentStoreId)).then(() => {
                this.storeService.menuRefreshTrigger.next();
              });
            } else {
              this.storeService.menuRefreshTrigger.next();
            }
          } else if (payload.type === 'modifiers_batch' && payload.modifiers?.length) {
            console.log(`[MENU_MQTT_DEBUG] Handling MODIFIERS_BATCH, modifiers=${payload.modifiers.length} action=${payload.action} group=${payload.modifier_group?.id}`);
            // ENG-4644: Batch modifier updates (e.g. from update_modifier_group)
            // Pass modifier_group info so group-level fields (enable_pre_mod, etc.) are also patched in cache.
            this.menuService.applyModifiersBatch(currentStoreId, payload.modifiers, payload.action || 'updated', payload.modifier_group);
            if (payload.version) this.menuService.setMenuVersion(currentStoreId, payload.version);
            this.storeService.menuRefreshTrigger.next();
            console.log(`[MENU_MQTT_DEBUG] MODIFIERS_BATCH applied + menuRefreshTrigger fired`);
          } else {
            console.log(`[MENU_MQTT_DEBUG] Handling FULL_REFRESH (unknown type or fallback), type=${payload.type}`);
            // Full refresh (menu structure change, bulk edit, etc.)
            this.menuService.clearMenuCache(currentStoreId);
            this.menuService.syncFullMenu(String(currentStoreId)).then(() => {
              this.storeService.menuRefreshTrigger.next();
              console.log(`[MENU_MQTT_DEBUG] FULL_REFRESH complete + menuRefreshTrigger fired`);
            });
          }
        } catch (e) {
          console.error(`[MENU_MQTT_DEBUG] EXCEPTION parsing MQTT payload`, e);
          // Fallback: if payload parsing fails, clear cache and re-fetch
          this.menuService.clearMenuCache(currentStoreId);
          this.menuService.syncFullMenu(String(currentStoreId)).then(() => {
            this.storeService.menuRefreshTrigger.next();
          });
        }
      });

    // Store config refresh (tax, surcharge, tips, feature flags, pause status, etc.)
    // When store settings change on the backend, an MQTT message is published here.
    // We re-fetch the full store object and persist to Dexie so all components update.
    this.mqttService.observe(`/order_app/${currentStoreId}/sub`).pipe(
      takeUntil(this.destroySubject)
    ).subscribe((mqttMsg: IMqttMessage) => {
      try {
        const payload = JSON.parse(mqttMsg.payload.toString());
        if (payload.refresh) {
          this.storeService.refresh(this.store);
        }
      } catch (e) { }
    });

    // G-4: Reconciliation timer — periodic version check as MQTT backup.
    // Only for local-first POS stores that use the menu cache.
    if (this.store?.feature_flag?.['local_first_pos']) {
      this.menuVersionCheckInterval = setInterval(() => {
        const localVersion = this.menuService.getMenuVersion(currentStoreId);
        if (localVersion > 0) {
          this.menuService.checkMenuVersion(currentStoreId).subscribe(
            resp => {
              // Re-read local version — MQTT may have delivered a granular
              // update and bumped it while the HTTP request was in-flight.
              const freshLocal = this.menuService.getMenuVersion(currentStoreId);
              if (resp.version > freshLocal) {
                // Don't call clearMenuCache — it wipes L1, leaving empty menus
                // while syncFullMenu fetches. syncFullMenu overwrites L1 naturally.
                this.menuService.setMenuVersion(currentStoreId, resp.version);
                this.menuService.syncFullMenu(String(currentStoreId)).then(() => {
                  this.storeService.menuRefreshTrigger.next();
                });
              }
            },
            () => {} // Silently ignore network errors — next interval will retry
          );
        }
      }, 60_000);
    }
  }
}
